import React from 'react';

const CounterOne = () => {
  return (
    <section className="counter-one">
      <div className="counter-one__bg" style={{ backgroundImage: 'url(assets/images/23.jpg)' }}></div>
      <div className="container">
        <div className="counter-one__inner">
          <ul className="counter-one__count-list list-unstyled">
            <li className="wow fadeInLeft" data-wow-delay="100ms">
              <div className="counter-one__single">
                <div className="counter-one__single-shape"></div>
                <div className="counter-one__icon-inner">
                  <div className="counter-one__icon"><span className="icon-user-1"></span></div>
                </div>
                <div className="counter-one__content count-box">
                  <h3 className="counter-one__count"><span className="count-text" data-stop="220" data-speed="1500"></span>2K</h3>
                  <p className="counter-one__text">Children Educated</p>
                </div>
              </div>
            </li>
            <li className="wow fadeInLeft" data-wow-delay="200ms">
              <div className="counter-one__single">
                <div className="counter-one__single-shape"></div>
                <div className="counter-one__icon-inner">
                  <div className="counter-one__icon"><span className="icon-capital"></span></div>
                </div>
                <div className="counter-one__content count-box">
                  <h3 className="counter-one__count"><span className="count-text" data-stop="95" data-speed="1500"></span>1M+</h3>
                  <p className="counter-one__text">Funds Raised</p>
                </div>
              </div>
            </li>
            <li className="wow fadeInRight" data-wow-delay="300ms">
              <div className="counter-one__single">
                <div className="counter-one__single-shape"></div>
                <div className="counter-one__icon-inner">
                  <div className="counter-one__icon"><span className="icon-interactions"></span></div>
                </div>
                <div className="counter-one__content count-box">
                  <h3 className="counter-one__count"><span className="count-text" data-stop="150" data-speed="1500"></span>12K</h3>
                  <p className="counter-one__text">Team Members</p>
                </div>
              </div>
            </li>
            <li className="wow fadeInRight" data-wow-delay="400ms">
              <div className="counter-one__single">
                <div className="counter-one__icon-inner">
                  <div className="counter-one__icon"><span className="icon-financing"></span></div>
                </div>
                <div className="counter-one__content count-box">
                  <h3 className="counter-one__count"><span className="count-text" data-stop="32" data-speed="1500"></span>1M+</h3>
                  <p className="counter-one__text">Donations to Date</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CounterOne;
